/*
 * Guarded against double-execution: more than one section emits a
 * <script src="ds-reveal.js"> tag, and duplicate script tags with the same src
 * DO each execute -- a bare top-level `class DsReveal` then throws
 * "Identifier 'DsReveal' has already been declared" and kills the whole file.
 */
if (!customElements.get('ds-reveal')) {
/*
 * ds-reveal — supplies the `.ds-in` class that snippets/ds-section.liquid
 * animates towards. One shared IntersectionObserver per element, unobserved
 * after firing. Enhancement only: if this script never runs, the matching
 * `@media (scripting: none)` rule in each section keeps content visible.
 */
class DsReveal extends HTMLElement {
  connectedCallback() {
    const targets = this.querySelectorAll('[data-ds-anim]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('ds-in'));
      return;
    }

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ds-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    targets.forEach((el) => this.observer.observe(el));
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.get('ds-reveal') || customElements.define('ds-reveal', DsReveal);

}
